// zh translations
export const ZH_TRANSLATIONS: { [key: string]: string } = {

    "--DropoffLateReason": "-- 还车迟到原因 --",
    "--FundingSource--": "-- 资金来源 --",
    "--PickupLateReason": "-- 取件迟到原因 --",
    "--Seats--": "-- 座位 --",
    "--Select--": "-- 选择 --",
    "--SelectAccountStatus": "-- 选择账户状态 --",
    "--SelectAssist--": "-- 选择辅助 --",
    "--SelectBodyType": "-- 选择体型 --",
    "--SelectBroker--": "-- 选择经纪商 --",
    "--SelectCancelReasons": "-- 选择取消原因 --",
    "--SelectCapacity--": "-- 选择容量 --",
    "--SelectCompetency--": "-- 选择能力 --",
    "--SelectCorporateUser": "-- 选择企业用户 --",
    "--SelectDateFormat": "-- 选择日期格式 --",
    "--SelectDay--": "-- 选择日期 --",
    "--SelectDiagnosismedicalCond": "-- 选择诊断/医疗状况 --",
    "--SelectDoModifier": "-- 选择 DO 修改器 --",
    "--SelectDrivers--": "-- 选择驱动程序 --",
    "--SelectDrivers--2": "-- 选择驱动程序 --",
    "--SelectEmploymentType": "-- 选择就业类型 --",
    "--SelectEquipment--": "-- 选择设备 --",
    "--SelectFleet--": "-- 选择机队 --",
    "--SelectFs--": "-- 选择 FS --",
    "--SelectFuelType": "-- 选择燃油类型 --",
    "--SelectGroup--": "-- 选择组 --",
    "--SelectMapper--": "-- 选择映射器 --",
    "--SelectMemberRole": "-- 选择会员角色 --",
    "--SelectMethod--": "-- 选择方法 --",
    "--SelectMonth--": "-- 选择月份 --",
    "--SelectOperationsManager": "-- 选择运营经理 --",
    "--SelectPlatformportal--": "-- 选择平台/门户 --",
    "--SelectPosition--": "-- 选择职位 --",
    "--SelectProficiency--": "-- 选择熟练程度 --",
    "--SelectPuModifier": "-- 选择PU改性剂--",
    "--SelectReason--": "-- 选择原因 --",
    "--SelectRoleType": "-- 选择角色类型 --",
    "--SelectServiceAreas": "-- 选择服务区域 --",
    "--SelectShiftAlign": "-- 选择移位对齐 --",
    "--SelectSpacetype--": "-- 选择空间类型 --",
    "--SelectStateCode": "-- 选择州代码 --",
    "--SelectStationManager": "-- 选择站管理器 --",
    "--SelectStatus--": "-- 选择状态 --",
    "--SelectStatuss--": "-- 选择状态 --",
    "--SelectTemplate--": "-- 选择模板 --",
    "--SelectTimeFormat": "-- 选择时间格式 --",
    "--SelectType--": "-- 选择类型 --",
    "--SelectVehicle--": "-- 选择车辆 --",
    "--ServiceArea--": "-- 服务范围 --",
    "--SpaceType--": "-- 空间类型 --",
    "--selectRequiredOdometer--": "--选择所需的里程表--",
    "--selectStatus--": "--选择状态--",
    "-selectFundingSource-": "-选择资金来源-",
    "10min": "10分钟",
    "15min": "15分钟",
    "1HourViolation": "1 小时违规",
    "30min": "30分钟",
    "Amendments": "修正案",
    "Announcement": "公告",
    "Cities Zones": "城市区域",
    "Companies": "公司",
    "Drivers": "司机",
    "Drivers Load": "驱动负载",
    "Equipment Planning": "设备规划",
    "Equipments": "设备",
    "Funding Sources": "资金来源",
    "Holidays": "假期",
    "Late Forecast": "延迟预报",
    "Late Reasons": "迟到的原因",
    "Level of Service": "服务水平",
    "Mapper": "映射器",
    "Members": "会员",
    "Miles For Bucks": "雄鹿里程",
    "New Trip": "新旅程",
    "Offered": "提供",
    "Payors": "付款人",
    "Profiling": "分析",
    "Quarters": "宿舍",
    "Schedule": "时间表",
    "Service Areas": "服务范围",
    "Shift Override": "班次覆盖",
    "Space Type Checklist": "空间类型清单",
    "Space Types": "空间类型",
    "Staff": "员工",
    "Standing Orders": "常规订单",
    "Templates": "模板",
    "Timesheet": "时间表",
    "Trip Sheet": "行程单",
    "Vehicles": "车辆",
    "Violations": "违规行为",
    "aaccountStatusIsRequired": "账户状态为必填项",
    "accept": "接受",
    "accepted": "已接受",
    "acceptedTrips": "接受的旅行",
    "accidentAndIncidentTraining": "事故和事故征候培训",
    "accountStatus": "账户状态",
    "accountStatusIsRequired": "账户状态为必填项",
    "acknowledgeByDriver": "司机确认",
    "act": "法案",
    "action": "行动",
    "actions": "行动",
    "actualShift": "实际班次",
    "add": "+ 添加",
    "addAddon": "添加插件",
    "addAmendment": "添加修改",
    "addAnnouncement": "添加公告",
    "addAppointmentType": "添加预约类型",
    "addBeneficiary": "添加受益人",
    "addBreak": "添加中断",
    "addBroker": "添加经纪商",
    "addCancelReason": "添加取消原因",
    "addChecklist": "添加清单",
    "addCity": "添加城市",
    "addCompany": "添加公司",
    "addDistribution": "添加分销",
    "addDriver": "添加驱动程序",
    "addEquipment": "添加设备",
    "addFundingSource": "添加资金来源",
    "addHoliday": "添加假期",
    "addLegButton": "+ 腿",
    "addLevelOfService": "添加服务级别",
    "addMapper": "添加映射器",
    "addMember": "添加会员",
    "addModifierCode": "添加修改代码",
    "addPayor": "添加付款人",
    "addPrimaryDiagnose": "添加初步诊断",
    "addQuarter": "添加季度",
    "addRate": "添加率",
    "addReason": "添加原因",
    "addServiceArea": "添加服务区",
    "addShift": "添加班次",
    "addShiftOverride": "添加 Shift 覆盖",
    "addSpaceType": "添加空间类型",
    "addStaff": "添加员工",
    "addTemplate": "添加模板",
    "addTips": "添加提示",
    "addTripHeader": "添加",
    "addVehicle": "添加车辆",
    "addYourComment": "添加您的评论",
    "addYourComment2": "添加您的评论...",
    "addZone": "添加区域",
    "additionalInformation": "附加信息",
    "additionalNote": "附加说明",
    "addonButton": "+ 插件",
    "addonItemLabel": "项目",
    "addonItemRequired": "项目为必填项",
    "addonServicesHeader": "插件服务",
    "address": "地址：",
    "addressLabel": "地址",
    "addressName": "地址名称",
    "addressNameIsRequired": "地址 姓名 为必填项",
    "addressRequired": "地址为必填项",
    "addressValidationAlert": "地址验证警报",
    "addupdateSignature": "添加/更新签名",
    "adjustTrip": "调整行程",
    "adjustment": "调整",
    "adlAmbulanceDriversLicense": "ADL（救护车驾驶员执照）",
    "adlImageIsRequired": "需要 ADL 图片",
    "admin": "管理员",
    "agent": "代理",
    "alarming": "令人震惊",
    "alarmingTrips": "令人震惊的行程",
    "alcReminder": "自动LC提醒",
    "alcoholScreeningRecentScreen": "酒精筛查（近期筛查）",
    "algorithm": "算法",
    "all": "全部",
    "allDrivers": "所有司机",
    "allMessages": "所有消息",
    "allNotifications": "所有通知",
    "allowAttendee": "允许与会者",
    "allowAuthorizationNumberFor": "允许一项护理的授权号",
    "allowPlacement": "允许安置",
    "allowCamera": "允许拍照",
    "allowCapacityViolation": "允许容量违规",
    "allowCapacityViolations": "允许容量违规",
    "allowIncentive": "允许激励",
    "allowIpcr": "允许 IPCR",
    "allowAuditLogs": "允许审计日志",
    "allowCoverage": "允许覆盖",
    "auditlogs": "审计日志",
    "allowMulti-factorAuthenticat": "允许多重身份验证",
    "allowNearBy": "允许附近",
    "allowOnboardViolations": "允许船上违规行为",
    "allowPossibility": "允许可能性",
    "allowSms": "允许短信",
    "allowTimesheet": "允许时间表",
    "allowVoiceAssistance": "允许语音协助",
    "ambulance": "救护车",
    "ambulette": "安布莱特",
    "amendment": "修正案",
    "amountIsRequired": "金额为必填项",
    "announcements": "公告",
    "api": "应用程序编程接口",
    "appealed": "已上诉",
    "appky": "应用基",
    "applyIncentive": "申请奖励",
    "appointmentDirectionInside": "中心内",
    "appointmentDirectionLabel": "预约方向",
    "appointmentDirectionOutside": "中心外",
    "appointmentTime": "预约时间",
    "appointmentTimeIsRequired": "需要预约时间",
    "appointmentTypeLabel": "预约类型",
    "appointmentTypeRequired": "预约类型为必填项",
    "appointmentTypefileIsRequire": "预约类型（文件）为必填项",
    "appointmentTypetpIsRequired": "预约类型(TP) 为必填项",
    "approachingAlert": "接近警报",
    "approachingTrips": "即将出行",
    "approve": "批准",
    "approved": "已批准",
    "aptOrSuiteIs": "需要 APT 或 Suite",
    "aptOrSuiteLabel": "公寓/套房",
    "aptOrSuiteRequired": "需要APT/套房",
    "aptsuiteroom": "公寓/套房/房间",
    "arabicLanguageLabel": "阿拉伯语",
    "archive": "存档",
    "archived": "已存档",
    "archivedTrips": "存档旅行",
    "areYouSureYou": "您确定要将这次旅行移至新时间吗？",
    "areYouSureYou2": "您确定要取消吗？",
    "areYouSureYou3": "您确定要更新里程表吗？",
    "areYouSureYou4": "您确定要根据家长常规订单在该特定日期创建行程吗？",
    "areYouSureYou5": "您确定要清除系统中的所有行程数据吗？您将必须再次重新导入数据才能将任何行程分配给司机，因为这是永久性操作？",
    "arn": "ARN",
    "arrears": "欠款",
    "arrearsLabel": "欠款标签",
    "arrived": "到达",
    "assign": "分配",
    "assignTrip": "分配行程",
    "assignMultipleTrips": "分配多个行程",
    "assignVehicle": "分配车辆",
    "assignedTrips": "指定行程",
    "assist": "协助",
    "assistShiftAlign": "辅助换档对齐",
    "assistShiftAlignIs": "需要辅助换档对齐",
    "assistShiftDayWise": "辅助换班（白天）",
    "assistShiftEnd": "辅助换档结束",
    "assistShiftEndIs": "需要辅助换档结束",
    "assistShiftStart": "辅助换档启动",
    "assistShiftStartIs": "需要辅助换档启动",
    "assistsLabel": "助攻",
    "associateImage": "关联图像",
    "atLeastOneAssist": "至少需要一次辅助换班",
    "atleastOneDayShift": "至少需要一天班",
    "atleastOneDriverIs": "至少需要一名司机",
    "attachPdfButton": "附上PDF",
    "attchedPdf": "附PDF",
    "authNumberLabel": "授权号",
    "authorizationNumberIsRequire": "需要授权号",
    "authorizer": "授权人",
    "autoAssignWillCall": "自动分配将呼叫",
    "autoGenerate": "自动生成",
    "autoRefresh": "自动刷新",
    "autoTimeStamp": "自动时间戳",
    "autoTimestamp": "自动时间戳",
    "autoZoom": "自动变焦",
    "available": "可用",
    "avatar": "头像",
    "backToLogin": "返回登录",
    "background": "背景",
    "badPhonenumber": "错误的电话号码",
    "banked": "已存入银行",
    "baseFare": "基本票价",
    "baseFareCode": "基本票价代码",
    "baseFareCodeIs": "需要基本票价代码",
    "baseFareFor": "基本票价",
    "baseFareForIs": "基本票价为必填项",
    "baseFareIsRequired": "需要基本票价",
    "batch": "批次",
    "bedBugProtocol": "臭虫协议",
    "bedLengthIsRequired": "床的长度是必需的",
    "beginAt": "开始于：",
    "billTo": "帐单收件人 *",
    "billerNote": "账单人备注",
    "billerNotes": "开票人备注",
    "billing": "计费",
    "bloodbornePathogenTrainingEx": "血源性病原体训练（EXP）",
    "bloodbornePathogens": "血源性病原体",
    "bodyType": "体型",
    "bodyTypeIsRequired": "体型为必填项",
    "both": "两者都",
    "break": "休息",
    "breakCushion": "休息垫：",
    "breakFinished": "休息（完成）",
    "breakScheduled": "休息（预定）",
    "breaks": "休息时间",
    "broker-img": "经纪人-img",
    "brokerConfiguration": "经纪商配置",
    "brokerId": "经纪商ID",
    "brokerIsRequired": "需要经纪人",
    "bsr": "缓冲状态报告",
    "bsr2": "缓冲状态报告：",
    "bulkConfirmation": "批量确认",
    "businessNumber": "商业号码",
    "businessNumberIsRequired": "企业号码为必填项",
    "businessReport": "业务报告",
    "businessReports": "业务报告",
    "busy": "忙",
    "bySavingTheInformation": "通过保存此表格中的信息，您作为该组织的授权代表特此证明，该信息准确地反映了该组织完成的运输。您特此证明，据您所知，这些信息是真实、准确和完整的，并且您了解任何伪造、遗漏或隐瞒重要事实的行为都可能使您和/或组织承担合同、行政、民事或刑事责任。您还了解，这些运输的所有文件均应根据各自保险经纪人及其附属公司的记录维护政策进行维护。",
    "caTimesheet": "加州时间表",
    "calculateButton": "计算",
    "calculateLocalMiles": "计算当地里程",
    "call": "致电",
    "callMemberToVerify": "致电会员确认取消",
    "cancel": "取消",
    "cancelCharges": "取消费用",
    "cancelChargesIsRequired": "需要取消费用",
    "cancelReason": "取消原因",
    "cancelReasons": "取消原因",
    "cancelReasonsIsRequired": "需要取消原因",
    "cancelTrip": "取消行程",
    "canceled": "取消",
    "cancellationNotes": "取消须知",
    "cancelled": "取消",
    "cancelledAt": "取消时间：",
    "cancelledFee": "取消费用 *",
    "cancelledTripsSection": "取消的行程部分",
    "capacities": "产能",
    "capacity": "容量",
    "capacityIsRequired": "容量为必填项",
    "careGiverInformation": "照顾者信息",
    "caregiverDetailsAreRequired": "需要提供看护者详细信息",
    "centeneAttestationIss": "Centene 证明 (ISS)",
    "certificateOfCompletionOnlok": "结业证书（ONLOK）",
    "certificationIsRequired": "需要认证",
    "certifiedMechanicVerificatio": "认证机械师验证",
    "cf": "CF：",
    "change": "改变",
    "changePassword": "更改密码",
    "checkin": "签到",
    "checklist": "清单",
    "checklistIsRequired": "需要检查清单",
    "checklistNameIsRequired": "清单名称为必填项",
    "checkout": "结账",
    "chineseLanguageLabel": "中文",
    "city": "城市",
    "cityIsRequired": "城市为必填项",
    "citystate": "城市/州",
    "claim": "索赔",
    "claim2": "+ 索赔",
    "claimIsRequired": "需要索赔",
    "claims": "索赔",
    "clear": "清除",
    "clearVehicle": "清除车辆",
    "clientIdLabel": "客户 ID / 会员 ID / MA# / AHCCCS#",
    "clientIdRequired": "客户 ID / 会员 ID / MA# / AHCCCS# 为必填项",
    "clone": "克隆",
    "close": "关闭",
    "closePanel": "关闭面板",
    "closeSidebar": "关闭侧边栏",
    "closer": "更近一些",
    "cms1500": "CMS 1500",
    "code": "代码",
    "codeIsRequired": "需要代码",
    "color": "颜色",
    "colorIsRequired": "颜色为必填项",
    "comment": "评论",
    "commentIsRequired": "需要评论",
    "comments": "评论",
    "companiesStats": "公司统计",
    "company-img": "公司img",
    "companyAlias": "公司别名 *",
    "companyBillingName": "公司帐单名称",
    "companyFaxNumber": "公司传真号码",
    "companyImage": "公司形象",
    "companyImageIsRequired": "需要公司形象",
    "companyInTake": "公司收入 (%)",
    "companyInTakeIs": "接受公司为必填项",
    "companyMobileNumber": "公司手机号码",
    "companyMobileNumberIs": "公司手机号码为必填项",
    "companyName": "公司名称",
    "companyNameIsRequired": "公司名称为必填项",
    "companyNotes": "公司笔记",
    "companyPhoto": "公司照片",
    "competency": "能力",
    "competencyIsRequired": "需要具备能力",
    "completed": "已完成",
    "completedFee": "完成费用*",
    "completedTimeIsRequired": "需要完成时间",
    "compliancePlanTrainingFraud": "合规计划培训（欺诈、浪费和滥用）（行为准则）",
    "configurations": "配置",
    "confirm": "确认",
    "confirmNewPassword": "确认新密码",
    "confirmPassword": "确认密码",
    "confirmPasswordDidtMatch": "确认密码不匹配",
    "confirmPasswordIsRequired": "需要确认密码",
    "confirmationReport": "确认报告",
    "confirmationText": "确认文字",
    "confirmedLabel": "已确认",
    "contactNumber": "联系电话",
    "contactNumberIsRequired": "联系电话为必填项",
    "contractSent": "合同已发送",
    "corporate": "企业",
    "corporateOdometerRequired": "需要公司里程表",
    "corporatePrivatePay": "企业/私人薪酬",
    "costCenter": "成本中心",
    "costCenterIsRequired": "需要成本中心",
    "coverImage": "封面图片",
    "covid": "新冠病毒",
    "covid-19Vaccine": "COVID-19 疫苗",
    "covid-19VaccineDeclined": "COVID-19 疫苗被拒绝",
    "cprFirstAidCertification": "心肺复苏/急救认证开始日期 (EXP)",
    "cprFirstAidCertification2": "心肺复苏 / 急救认证到期日 (EXP)",
    "createBucket": "创建桶",
    "createButton": "创建",
    "createSchedule": "创建时间表",
    "createTrip": "创建行程",
    "createTripsManually": "手动创建行程",
    "created": "已创建",
    "createdTimeIsRequired": "创建时间为必填项",
    "credentialInformation": "凭证信息",
    "credentialing": "资格认证",
    "credentials": "凭证",
    "criminalBackgroundCheck": "犯罪背景调查",
    "criminalRecordAlcoholOr": "犯罪记录（酗酒或吸毒）",
    "ctc": "CTC",
    "ctcBot": "CTC机器人",
    "ctcInvoice": "CTC发票",
    "ctcMarketplace": "CTC 市场",
    "ctcTrips": "CTC 旅行",
    "currentMeter": "电流表",
    "currentMileageIsRequired": "需要当前里程",
    "currentPassword": "当前密码",
    "currentPasswordIsRequired": "需要当前密码",
    "custom": "定制",
    "daily": "每日",
    "dashboard": "仪表板",
    "date": "日期",
    "dateFormat": "日期格式",
    "dateFormatIsRequired": "日期格式为必填项",
    "dateIsRequired": "日期为必填项",
    "dateOfInspection": "检查日期",
    "dateOfInspectionIs": "检查日期为必填项",
    "dateOfService": "服务日期",
    "dateRange": "日期范围 *",
    "dayRequired": "需要当天",
    "days": "天数",
    "days2": "天数",
    "daysIsRequired": "天数为必填项",
    "ddmmyyyy": "日/月/年",
    "deadMiles": "死亡里程",
    "deadMilesRateIs": "死里程率是必需的",
    "deadheadTimeToPickup": "空载时间（到接载）",
    "decline": "拒绝",
    "defensiveDrivingCourse": "防御性驾驶课程",
    "delete": "删除",
    "deleteAll": "全部删除",
    "demo": "演示",
    "description": "描述",
    "descriptionIsRequired": "描述为必填项",
    "detail": "详情",
    "details": "详情",
    "diagnosismedicalCondition": "诊断/医疗状况",
    "diagnosismedicalConditionIsR": "需要诊断/医疗状况",
    "dimensions": "尺寸",
    "discount": "折扣",
    "discountLabel": "折扣标签",
    "dispatchMonthDay": "发货月日 *",
    "dispatcher": "调度员",
    "dispatcherNotesLabel": "调度员备注",
    "display": "显示",
    "displayMode": "显示模式",
    "displayNameLabel": "显示名称",
    "displayNameRequired": "显示名称为必填项",
    "displaySection": "显示部分",
    "do": "DO",
    "doModifier": "溶氧调节剂",
    "doModifierIsRequired": "需要 DO 修饰符",
    "doa": "DOA",
    "dobLabel": "出生日期",
    "dobRequired": "出生日期为必填项",
    "done": "完成",
    "dos": "操作系统：",
    "dot": "交通部",
    "dotPhysicalExamAnnual": "DOT 体检（每年或根据要求）",
    "downBaseAddress": "向下基地址",
    "download": "下载",
    "downloadCsv": "下载 CSV 文件",
    "downloadPdf": "下载PDF",
    "downloadPdfReport": "下载PDF报告",
    "downloadReport": "下载报告",
    "drawRoute": "绘制路线",
    "driveDistance": "行驶距离",
    "driver": "司机",
    "driver-score-chartsWorks": "驾驶员分数图表有效！",
    "driver2": "（司机）",
    "driverAddress": "司机地址",
    "driverAddressIsRequired": "司机地址为必填项",
    "driverAlerts": "驾驶员警报",
    "driverBreak": "司机休息",
    "driverBreakdown": "驱动器故障",
    "driverImage": "驾驶员形象",
    "driverInTake": "司机收入 (%)",
    "driverInTakeIs": "需要司机参加",
    "driverInformation": "司机信息",
    "driverIsGettingLate": "司机迟到了",
    "driverIsIdle": "司机空闲（无行程）",
    "driverIsLate": "司机迟到",
    "driverIsOverloaded": "司机超载（>12 趟）",
    "driverLoad": "驱动负载",
    "driverName": "司机姓名",
    "driverNotesLabel": "驾驶员注意事项",
    "driverOdometer": "驾驶员里程表",
    "driverProfile": "驾驶员资料",
    "driverRequired": "需要司机",
    "driverRoadTrainingEvidence": "驾驶员道路培训（证据）",
    "driverSched": "司机时间表",
    "driverShift": "驾驶员换班",
    "driverShiftDayWise": "驾驶员轮班（白天）",
    "driverVerificationAlcohol": "驾驶员验证（酒精）",
    "driverVerificationDrug": "驾驶员验证（药物）",
    "driverdisplayname": "驱动程序.显示名称",
    "driversDrugTest": "驾驶员药检",
    "drivingRecordMeetsRequiremen": "驾驶记录（符合要求）",
    "drop": "掉落",
    "dropoffAddress": "还车地址",
    "dropoffAddressIsRequired": "还车地址为必填项",
    "dropoffEarly": "提前还车：",
    "dropoffHeader": "下车",
    "dropoffLate": "还车晚点：",
    "dropoffLateReason": "还车迟到原因：",
    "dropoffLateReason2": "还车迟到原因",
    "dropoffWise": "明智下车",
    "dryRun": "试运行",
    "dryRunCode": "试运行代码",
    "dryRunCodeIs": "需要试运行代码",
    "dsr": "数字SR：",
    "dt": "DT",
    "dt2": "设备名称：",
    "dueDay": "到期日 *",
    "duplicate": "重复",
    "durationIsRequired": "需要持续时间。",
    "dvCompetencyAssessmentIss": "DV 能力评估 (ISS)",
    "dvRequired": "需要 DV",
    "earlyActionActualVsScheduled": "早期行动（实际开始与预定开始）",
    "earlyEta": "早期预计到达时间",
    "editNotes": "编辑注释",
    "editProfile": "编辑个人资料",
    "editShift": "编辑班次",
    "editTripHeader": "编辑",
    "elderAbuseTraining": "虐待老人培训",
    "eligibility": "资格",
    "eligibilityStatusIsRequired": "需要资格状态",
    "eligible": "符合资格",
    "email": "电子邮件：",
    "emailAddress": "电子邮件地址",
    "emailAddressIsRequired": "电子邮件地址为必填项",
    "emailConfiguration": "电子邮件配置",
    "emailIsNotValid": "电子邮件无效",
    "emailLabel": "电子邮件",
    "emailRequired": "电子邮件为必填项",
    "emergencyAndEvacuationTraini": "应急和疏散培训",
    "employeeId": "员工编号",
    "employeeIdIsRequired": "需要提供员工 ID",
    "employerNameIsRequired": "雇主名称为必填项",
    "employmentType": "就业类型",
    "employmentTypeIsRequired": "就业类型为必填项",
    "emtDriver": "急救司机",
    "emtLicense": "急救医师执照",
    "emtLicenseImageIs": "需要 EMT 许可证图像",
    "endDateLabel": "结束日期",
    "endDateRequired": "结束日期为必填项",
    "endOfShift": "轮班结束",
    "endTime": "结束时间",
    "endTimeIsRequired": "结束时间为必填项",
    "ended": "（已完结）",
    "endedAt": "结束于：",
    "englishLanguageLabel": "英语",
    "ensureThereAreNo": "⚠️ 确保结肠周围没有空间。触发搜索至少需要 3 个字符。",
    "enterTitle": "输入标题",
    "enterYourEmail": "输入您的电子邮件",
    "enterYourEmailAnd": "输入您的电子邮件并选择角色以接收重置链接",
    "enterYourNewPassword": "在下面输入您的新密码",
    "equipmentsAreRequired": "需要装备",
    "esf": "欧洲基金：",
    "estimatedFareLabel": "预计票价",
    "estimatedFares": "预计票价",
    "estimatedPickupTimeLabel": "预计。聚氨酯：",
    "every": "每个",
    "exiting": "退出",
    "expandOnHover": "悬停时展开",
    "expectedAppointmentTimeLabel": "预计预约时间",
    "expectedAppointmentTimeMinError": "预计预约时间不能早于取件（日期和时间）。",
    "expectedAppointmentTimeRequired": "需要预计预约时间",
    "expenses": "费用",
    "expirationDate": "有效期",
    "expirationDateIsRequired": "到期日期为必填项",
    "expired": "已过期",
    "expiredTrips": "过期行程",
    "expiredTripsRoutes": "过期行程路线",
    "expiryDate": "到期日",
    "expiryDateIsRequired": "到期日期为必填项",
    "exportCsv": "导出 CSV",
    "extensiondispatcherNumber": "分机/调度员号码",
    "extensiondispatcherNumberIsR": "需要分机/调度员号码",
    "exteriorInformation": "外观信息",
    "fare": "票价",
    "fareInformation": "票价信息",
    "faxNumber": "传真号码",
    "feedback": "反馈意见",
    "feet": "（脚）",
    "fetch": "获取",
    "fetchEta": "获取预计到达时间",
    "fetchTime": "获取时间",
    "file": "（文件）",
    "fileIsRequired": "需要文件",
    "fileName": "文件名",
    "filter": "过滤器",
    "fingerPrintLiveScan": "指纹实时扫描",
    "finished": "完成",
    "finishedAndCancelled": "已完成并取消",
    "finishedAt": "完成于：",
    "finishedCompleted": "完成/完成",
    "finishedTimeIsRequired": "完成时间为必填项",
    "finishedTrips": "已完成行程",
    "firstName": "名字",
    "firstNameIsRequired": "名字为必填项",
    "firstNameMustBe": "名字必须至少包含 3 个字符。",
    "fleet": "舰队",
    "fleetInformation": "船队信息",
    "fleetIsRequired": "需要车队",
    "floorLabel": "楼层",
    "floorRequired": "需要楼层",
    "florida": "佛罗里达州",
    "flu": "流感",
    "fluVaccine": "流感疫苗",
    "fluVaccineDeclined": "流感疫苗被拒绝",
    "focalPerson": "焦点人物",
    "focalPersonInformation": "焦点人物信息",
    "for": "对于",
    "force": "力",
    "forcedAcceptTrips": "强制接受旅行",
    "forgotPassword": "忘记密码",
    "forgotPassword2": "忘记密码？",
    "form837": "837 表格",
    "form837V2": "837 v2 表格",
    "freeQuota": "免费配额",
    "from": "来自",
    "fromIsRequired": "来自 为必填项",
    "fsIsRequired": "需要FS",
    "fuelType": "燃料类型",
    "fuelTypeIsRequired": "燃料类型为必填项",
    "fullTime": "全职",
    "fundingSourceAndValidity": "资金来源和有效期为必填项",
    "fundingSourceLabel": "资金来源",
    "noViolation": "无违规",
    "fundingSourceRequired": "资金来源为必填项",
    "fundingSources": "资金来源",
    "fundingSourcesAreRequired": "需要资金来源",
    "garage": "车库",
    "garageAddress": "车库地址",
    "garageAddressIsRequired": "车库地址为必填项",
    "gasCardNumber": "加油卡号码",
    "gasCardNumberIs": "加油卡号码为必填项",
    "genderFemale": "女",
    "genderLabel": "性别",
    "genderMale": "男",
    "genderOther": "其他",
    "genderRequired": "性别为必填项",
    "general": "一般",
    "georgia": "格鲁吉亚",
    "gisMiles": "地理信息系统里程",
    "goBackHome": "回家吧",
    "googleMiles": "谷歌里程",
    "groundClearanceIsRequired": "需要离地间隙",
    "groupByName": "按名称分组",
    "groupImageIsRequired": "需要团体图片",
    "groupName": "群组名称",
    "groupNameIsRequired": "群组名称为必填项",
    "groups": "团体",
    "gurneyTraining": "轮床训练",
    "handsFreeTraining": "免提培训",
    "haversineMiles": "半正矢英里",
    "height": "身高",
    "heightIsRequired": "高度为必填项",
    "hepatitis": "肝炎",
    "hhmm": "（高：毫米）",
    "hhmm2": "嗯哼",
    "hhmm3": "高:毫米",
    "hideOneHourException": "隐藏一小时例外",
    "hideThirdPartyDrivers": "隐藏第三方驱动程序",
    "hideUnassignedTrips": "隐藏未分配的行程",
    "hipaaPhiTrainingValid": "HIPAA / PHI 培训（永久有效）",
    "history": "历史",
    "holidayName": "节日名称",
    "holidayNameIsRequired": "假期名称为必填项",
    "hoodInformation": "引擎盖信息",
    "hospitalized": "住院治疗",
    "host": "主机",
    "howToUseThe": "🔍 如何使用搜索",
    "iaal": "亚洲航空学会",
    "ifYouAlterThe": "如果您更改旅行信息，使其与实际发生的旅行的详细信息不符，则您提交虚假陈述并构成犯罪。任何提交虚假陈述的人都将受到法律的最大程度的起诉。",
    "image": "图像",
    "imageIsRequired": "图片为必填项",
    "img-corporate": "img-企业",
    "importFile": "导入文件",
    "importingTripsFromBrokers": "从经纪人处导入行程",
    "inActiveReason": "积极理性",
    "inActiveReasonIs": "在主动原因中是必需的",
    "inMinutes": "（以分钟为单位）",
    "inProgress": "进行中",
    "inProgressTrips": "进行中的旅行",
    "inProgressRoutes": "进行中的路线",
    "inReview": "审查中",
    "inVehicle": "车内",
    "inactive": "不活跃",
    "incentive": "激励",
    "incentiveIsRequired": "需要激励",
    "indiana": "印第安纳州",
    "ineligible": "不符合资格",
    "info": "信息",
    "informDriver": "通知司机",
    "information": "信息",
    "inspectionPassOrFail": "需要检查通过或失败",
    "interiorInformation": "内部信息",
    "invalidEmailFormat": "电子邮件格式无效",
    "invalidTrip": "无效行程",
    "invoice": "发票",
    "invoices": "发票",
    "ipaLabel": "IPA/FECA 编号",
    "ipaRequired": "需要 IPA / FECA 号码",
    "ipcr": "免疫荧光PCR",
    "isAcknowledgementOnFile": "确认书是否已存档？",
    "isCertificateOnFile": "证书有备案吗？",
    "isWave": "是波",
    "issueDate": "发行日期",
    "issueDateIsRequired": "发行日期为必填项",
    "itineries": "行程",
    "kpisdriverdisplayname": "kpis.driver.displayName",
    "language": "语言",
    "lastInspectionDateIs": "需要最后检查日期",
    "lastName": "姓氏",
    "lastNameIsRequired": "姓氏为必填项",
    "lastNameMustBe": "姓氏必须至少包含 3 个字符。",
    "lateCushion": "后期缓冲",
    "lateCushionIsRequired": "需要后期缓冲",
    "lateEta": "预计到达时间较晚",
    "lbs": "（磅）",
    "legCancellationAlert": "航段取消提醒",
    "legLabel": "腿-",
    "legalInformation": "法律信息",
    "legalName": "法定名称",
    "legalNameIsRequired": "法定名称为必填项",
    "legalNameMustBe": "法定名称必须至少包含 3 个字符。",
    "lengthIsRequired": "长度为必填项",
    "lengthMustBe3": "长度必须为 3",
    "levelOfServiceImage": "服务水平形象",
    "levelOfServiceLabel": "服务水平",
    "levelOfServiceRequired": "需要服务级别",
    "levelofservice-image": "服务水平形象",
    "licenseInformation": "许可证信息",
    "licenseNumber": "执照号码",
    "licenseNumberIsRequired": "许可证号为必填项",
    "licensePlate": "车牌",
    "licensePlateInformation": "车牌信息",
    "licensePlateIsRequired": "需要车牌",
    "lightsInformation": "灯光信息",
    "limitation": "局限性",
    "limitations": "局限性",
    "line": "线",
    "list": "列表",
    "listView": "列表视图",
    "livescanDojFbi": "实时扫描（司法部 + 联邦调查局）",
    "livescanDojOnly": "实时扫描（仅限司法部）",
    "load": "负载",
    "loadTimeIsRequired": "需要加载时间",
    "loadedMilesRateIs": "充值里程费率为必填项",
    "loadedTime": "加载时间",
    "loadedTimeToDropoff": "装载时间（到下车）",
    "loginInformation": "登录信息",
    "logisticareTemplate": "LogistiCare 模板",
    "logo": "标志",
    "logout": "退出",
    "logs": "日志",
    "los": "服务水平：",
    "losAndSpaceType": "损耗和空间类型为必填项",
    "lt": "LT",
    "lt2": "LT：",
    "lunch": "午餐",
    "maintenanceInformation": "维修信息",
    "maintenances": "维护保养",
    "makeItLive": "让它变得生动起来",
    "makeModel": "品牌和型号",
    "makeModelIsRequired": "品牌和型号为必填项",
    "mandatoryForCms1500": "（CMS 1500 表格必填）",
    "mandatoryForMedicaidAnd": "（医疗补助和 CMS 1500 表格强制填写）",
    "mandatoryForMedicaidAuth": "（医疗补助授权表必须填写）",
    "manifest": "清单",
    "manifestLegend": "显明传奇",
    "manual": "手册",
    "manualGenerate": "手动生成",
    "manualTrip": "手动跳闸",
    "mapperIsRequired": "需要映射器",
    "markComplete": "标记完成",
    "markMemberReady": "标记成员准备就绪",
    "markedReady": "标记为就绪",
    "markedReadyRoutes": "标记就绪路线",
    "markedReadyTrips": "标记为就绪的行程",
    "marketplace": "市场",
    "maxDistance": "最大距离：",
    "maxOnboardTime": "最长船上时间：",
    "maxTrips": "最大行程：",
    "meal": "膳食",
    "mealBreak": "用餐时间",
    "mechanicverificationsignatur": "mechanicVerification.signature",
    "medex": "麦德克斯",
    "medical": "医疗",
    "medicalIdIsRequired": "需要医疗ID",
    "medicalLogo": "医疗标志",
    "medicalTrip": "医疗旅行",
    "member-image": "会员形象",
    "memberLabel": "会员",
    "memberLoading": "会员加载中",
    "memberName": "会员姓名",
    "memberNotVisible": "会员不可见",
    "memberOnboard": "船上会员",
    "memberOnboardAt": "会员入职地点：",
    "memberRequired": "需要会员",
    "memberRoleIsRequired": "需要会员角色",
    "memberStatus": "会员状态",
    "memberType": "会员类型",
    "memberTypeIsRequired": "会员类型为必填项",
    "memberdisplayname": "成员.显示名称",
    "membersPhoneNumber": "会员电话号码",
    "merge": "合并",
    "messageAlerts": "消息提醒",
    "messages": "留言",
    "methadone": "美沙酮",
    "method": "方法",
    "methodIsRequired": "需要方法",
    "mfa": "（外交部）",
    "mfb": "MFb",
    "mi": "米",
    "mid": "中",
    "middleName": "中间名",
    "middleNameIsRequired": "中间名是必填项",
    "mile": "英里",
    "miles": "英里",
    "milesForBucksDriver": "雄鹿队车手里程",
    "milesForBucksPanel": "雄鹿里程面板",
    "milesLabel": "英里",
    "milesRequired": "需要里程",
    "minimum3CharactersRequired": "至少需要 3 个字符",
    "minimum5CharactersRequired": "至少需要 5 个字符",
    "mins": "分钟",
    "minutes": "分钟",
    "minutesIsRequired": "需要分钟数",
    "mm": "(毫米)",
    "mmddyyyy": "月/日/年",
    "mobileNumberLabel": "手机号码",
    "mobileNumberRequired": "手机号码为必填项",
    "model": "型号",
    "modelIsRequired": "型号为必填项",
    "modifierLabel": "修饰符",
    "modifierRequired": "需要修改器",
    "moicu": "莫重症监护病房",
    "moreFeaturesComingSoon": "📝 更多功能即将推出",
    "moreLabel": "更多...",
    "na": "N/A",
    "name": "名称",
    "nameIsRequired": "姓名为必填项",
    "nemt": "NEMT",
    "nemtStatistics": "NEMT统计",
    "newExpense": "新费用",
    "newInspection": "新检查",
    "newPassword": "新密码",
    "newPasswordIsRequired": "需要新密码",
    "no": "否",
    "noAgentTripsTo": "没有可显示的代理行程",
    "noAnswer": "无应答",
    "noCompanyDetailsTo": "没有可显示的公司详细信息",
    "noCtcTripTo": "没有显示 CTC 行程",
    "noDataToShow": "没有数据可显示",
    "noDetailsToShow": "没有详细信息显示",
    "noDirtRoadTrips": "没有土路旅行可显示",
    "noDriverDetailsTo": "没有可显示的驱动程序详细信息",
    "noEarning": "没有收入",
    "noEarningsToShow": "没有盈利可显示",
    "noMessageToShow": "没有消息可显示",
    "noNotificationsToShow": "没有可显示的通知",
    "noOfEscortsLabel": "陪护人数",
    "noOfEscortsRequired": "需要陪同人数",
    "noOfRoutes": "路线数量",
    "noOfRoutesAre": "所需路线数",
    "noOfSeats": "座位数",
    "noOfSeatsAre": "所需座位数",
    "noParsedFileFound": "未找到已解析的文件",
    "noRecords": "没有记录",
    "noShowCharges": "缺席费用",
    "noShowChargesIs": "需支付缺席费用",
    "noStatisticsToShow": "没有统计数据显示",
    "noTripLogsTo": "没有行程日志可显示",
    "noTripsAssign": "无行程分配",
    "noTripsToShow": "没有行程显示",
    "noUnassignedTrips": "没有未分配的行程",
    "non-transportVehicle": "非运输车辆",
    "none": "无",
    "notAvailable": "不可用",
    "notEligible": "不符合资格",
    "note": "注意事项",
    "notes": "注释",
    "notesAreRequired": "备注为必填项",
    "notificationMethod": "通知方式",
    "notifications": "通知",
    "odometer": "里程表",
    "odometerBegin": "里程表开始",
    "odometerBeginIsRequired": "里程表开始是必需的",
    "odometerBeginReadingIs": "需要里程表开始读数",
    "odometerEndIsRequired": "里程表端为必填项",
    "odometerRequired": "需要里程表",
    "odometerStart": "里程表开始",
    "odometerStartIsRequired": "需要里程表启动",
    "odometerStop": "里程表停止",
    "odometerStopIsRequired": "需要里程表停止",
    "of": "的",
    "offeredAccepted": "提供/接受",
    "offeredTrips": "提供的行程",
    "offline": "离线",
    "oigScreening": "监察办筛查",
    "onScene": "现场：",
    "onScene2": "现场",
    "onSceneReport": "现场报道",
    "onWay": "在路上",
    "onWayAt": "途中于：",
    "onboard": "机上",
    "oneHourException": "1 小时例外",
    "onq": "ONQ",
    "onscene": "现场",
    "onsceneTimeIsRequired": "需要现场时间",
    "onway": "安威",
    "open": "打开",
    "openMainMenu": "打开主菜单",
    "openUserMenu": "打开用户菜单",
    "opener": "开场白",
    "operations": "运营",
    "operationsManager": "运营经理",
    "operationsManagerIsRequired": "需要运营经理",
    "optIn": "选择输入",
    "orDragAndDrop": "或拖放",
    "ordAct": "法令/法案",
    "order": "订单",
    "orderIsRequired": "需要订购",
    "organizationId": "组织ID",
    "organizationIdIsRequired": "需要组织 ID",
    "otherInformation": "其他信息",
    "otherLegsHeader": "其他腿",
    "others": "其他",
    "otp": "一次性TP",
    "outsideShift": "外班",
    "outstandingTrips": "精彩旅行",
    "ownerDetails": "业主详情",
    "pageNotFound": "找不到页面",
    "paid": "付费",
    "panel": "面板",
    "parseTrips": "解析行程",
    "partTime": "兼职",
    "partner": "合伙人",
    "passenger": "客运",
    "passengerAssistanceAndCultur": "乘客援助和文化培训（EXP）",
    "passengerInformation": "旅客信息",
    "password": "密码",
    "passwordInformation": "密码信息",
    "passwordIsRequired": "需要密码",
    "passwordMustBeAtleast": "密码必须至少为 6 个字符",
    "passwordMustBeAtleast2": "密码必须至少 6 个字符",
    "passwordMustBeMaximum": "密码不得超过 16 个字符",
    "passwordMustBeMaximum2": "密码不得超过 16 个字符",
    "patient": "病人",
    "paymentConfirmed": "付款已确认",
    "paymentUnconfirmed": "付款未确认",
    "payorLabel": "付款人",
    "pending": "待定",
    "pendingFee": "待处理费用 *",
    "perMile": "每英里",
    "perMileCode": "每英里代码",
    "perMileCodeIs": "需要每英里代码",
    "perMileIsRequired": "每英里为必填项",
    "perMinIsRequired": "需要每分钟",
    "perMinute": "每分钟",
    "period": "期间",
    "permissions": "权限",
    "person": "人",
    "phoneNumberLabel": "电话号码",
    "phoneNumberRequired": "电话号码为必填项",
    "pickupAddress": "取货地址",
    "pickupAddressIsRequired": "取货地址为必填项",
    "pickupEarly": "提早取货：",
    "pickupHeader": "皮卡",
    "pickupLate": "接载延迟：",
    "pickupLateReason": "取件迟到原因",
    "pickupLateReasons": "取货迟到原因：",
    "pickupTme": "取货时间",
    "pickupWise": "皮卡明智",
    "placeNameLabel": "家庭/设施名称",
    "placeNameRequired": "住宅/设施名称为必填项",
    "planner": "规划师",
    "platform": "平台",
    "platformIsRequired": "需要平台",
    "platformportal": "平台/门户",
    "platformportalIsRequired": "需要平台/门户",
    "pleaseChooseAnyAbove": "请选择以上任一原因",
    "pleaseEnterDispatcherNotes": "请输入调度员备注",
    "pleaseEnterForDriver": "请输入驾驶员备注",
    "pleaseEnterTheClient": "请输入客户名称",
    "pleaseEnterTheDate": "请输入驾驶员机动车记录检查日期",
    "pleaseEnterTheDescription": "请输入描述",
    "pleaseEnterTheNote": "请输入备注",
    "pleaseEnterTheNotes": "请输入备注",
    "pleaseEnterThePrivate": "请输入私人备注",
    "pleaseEnterTheTime": "请输入时区",
    "pleaseNoteByUsing": "请注意，通过使用此功能，您必须忽略所有未在地面执行的行程，因此系统上不会伪造任何信息。",
    "pleaseSelectAtLeast": "请至少选择一名驱动程序。",
    "pleaseSelectCompanyTo": "请选择显示记录的公司",
    "pleaseSelectPrimaryMember": "请选择主要会员",
    "pleaseSelectTimeIn": "请选择时间于",
    "pleaseTakeNoticeFiling": "请注意：提交虚假陈述属于犯罪行为",
    "pngJpgGifUp": "PNG、JPG、GIF 高达 10MB",
    "policeClearance": "警察许可",
    "port": "港口",
    "portIsRequired": "端口为必填项",
    "position": "职位",
    "positionIsRequired": "职位为必填项",
    "possibilityButton": "可能性",
    "primary": "小学",
    "primaryDiagnoseLabel": "初步诊断",
    "primaryDiagnoseRequired": "需要初步诊断",
    "priority": "优先级",
    "priorityIsRequired": "需要优先",
    "privateLabel": "（私人）",
    "privateNote": "私人笔记",
    "proceed": "继续",
    "proficiency": "熟练程度",
    "proficiencyIsRequired": "需要熟练程度",
    "profile": "公司简介",
    "profileImage": "个人资料图片",
    "profileImageIsRequired": "个人资料图片是必需的",
    "profileInformation": "简介信息",
    "profileOverview": "简介概述",
    "profileimage": "个人资料图片",
    "protips": "普罗普斯",
    "proposedReadyTime": "建议的准备时间",
    "pu": "PU",
    "puModifier": "聚氨酯改性剂",
    "puModifierIsRequired": "需要PU改性剂",
    "pua": "PUA",
    "publicLabel": "（公开）",
    "pull-Out": "拉出",
    "pullEnd": "拉/结束",
    "punjabiLanguageLabel": "旁遮普语",
    "put": "PUT",
    "quantityLabel": "数量",
    "quantityRequired": "数量为必填项",
    "quarterdisplayname": "季度.显示名称",
    "quickFilter": "快速过滤",
    "quickSearch": "快速搜索",
    "quickSearchGuide": "🔍 快速搜索指南",
    "radiusIsRequired": "半径为必填项",
    "rates": "价格",
    "rawReport": "原始报告",
    "re-assign": "重新分配",
    "readyNotes": "准备好的笔记",
    "reason": "原因",
    "reasonIsRequired": "原因必填",
    "recurringDays": "重复天数",
    "recurringStatusRequired": "需要定期状态",
    "refS": "参考号",
    "reference": "参考",
    "reg": "注册：",
    "regular": "常规",
    "reject": "拒绝",
    "rejected": "被拒绝",
    "rejectedTrips": "被拒绝的旅行",
    "relation": "关系",
    "relationIsRequired": "需要有关系",
    "removeButton": "删除",
    "reply": "回复",
    "reports": "报告",
    "representativesignature": "代表.签名",
    "requiredOdometers": "所需里程表",
    "rescheduleTrip": "重新安排行程",
    "resendCode": "重新发送代码？",
    "reservationNo": "预订号码：",
    "reset": "重置",
    "resetPassword": "重置密码",
    "responseNightCode": "响应夜间代码",
    "responseNightCodeIs": "需要回复夜间代码",
    "rest": "休息",
    "restBreak": "休息时间",
    "return": "返回",
    "revenue": "收入",
    "reviewUrl": "审核网址",
    "rfLfRrLr": "（射频 低频 RR LR）",
    "rigNo": "钻机号",
    "rigNoIsRequired": "装备编号为必填项",
    "ripplingId": "涟漪 ID",
    "ripplingIdIsRequired": "涟漪 ID 为必填项",
    "rode": "罗德",
    "roleIsRequired": "角色为必填项",
    "roleType": "角色类型",
    "roleTypeIsRequired": "角色类型为必填项",
    "roomLabel": "房间",
    "roomRequired": "需要房间",
    "routeDetails": "路线详情",
    "routeView": "路线视图",
    "samScreening": "SAM 筛选",
    "save": "保存",
    "saveForAll": "为所有人保存",
    "saveTemplate": "保存模板",
    "scheduleShells": "附表 Shell",
    "scheduleShellsIsRequired": "需要附表 Shell",
    "scheduleTime": "安排时间",
    "scheduleTimeIsRequired": "需要安排时间",
    "scheduledTrips": "预定的行程",
    "score": "分数",
    "scoreDetails": "分数详情",
    "search": "搜索",
    "search2": "搜索...",
    "searchCompany": "搜寻公司",
    "searchDriver": "搜索驱动程序",
    "searchGroup": "搜索组",
    "searchMessages": "搜索消息",
    "searchVehicle": "搜寻车辆",
    "seconds": "（秒）",
    "secureComplianceTrainingAckn": "安全合规培训确认书",
    "secureType": "安全型",
    "seeAll": "查看全部",
    "seenBy": "看过的人",
    "selectAddonItemPlaceholder": "-- 选择项目 --",
    "selectAll": "选择全部",
    "selectAppointmentDirectionPlaceholder": "-- 选择预约方向 --",
    "selectAppointmentTypePlaceholder": "-- 选择预约类型 --",
    "selectAssistsPlaceholder": "-- 选择助攻 --",
    "selectBreak": "选择中断",
    "selectCorporate": "选择公司",
    "selectDate": "选择日期",
    "selectDateRange": "选择日期范围",
    "selectDos": "选择DOS",
    "selectDriver": "选择驱动程序",
    "selectDriverPlaceholder": "-- 选择驱动程序 --",
    "selectFundingSource": "选择资金来源",
    "selectFundingSourcePlaceholder": "-- 选择资金来源 --",
    "selectGenderPlaceholder": "-- 选择性别 --",
    "selectLevelOfService": "选择服务级别",
    "selectLevelOfServicePlaceholder": "-- 选择服务级别 --",
    "selectMember": "选择会员",
    "selectMemberPlaceholder": "-- 选择会员 --",
    "selectModifierPlaceholder": "-- 选择修改器 --",
    "selectNoOfEscortsPlaceholder": "-- 选择陪护人数 --",
    "selectPayorPlaceholder": "-- 选择付款人 --",
    "selectPrimaryDiagnosePlaceholder": "-- 选择主要诊断 --",
    "selectServiceArea": "选择服务区域",
    "selectServiceAreaPlaceholder": "-- 选择服务区域 --",
    "selectSpaceType": "选择空间类型",
    "selectSpaceTypePlaceholder": "-- 选择空间类型 --",
    "selectStatus": "选择状态",
    "selectTime": "选择时间",
    "selectTimezone": "选择时区",
    "selectType": "选择类型",
    "selectedDriverIsRequired": "需要选择驱动程序",
    "selectedServiceAreaIs": "需要选择服务区域",
    "selectedTrip": "精选行程",
    "send": "发送",
    "sendCode": "发送代码",
    "sendEmail": "发送电子邮件",
    "sendOnBreak": "休息时发送",
    "sentYouAnInvite": "向您发送了连接邀请。",
    "serviceAreaLabel": "服务区",
    "serviceAreaRequired": "服务区为必填项",
    "serviceAreas": "服务区域",
    "serviceAreasIsRequired": "服务区域为必填项",
    "serviceNameIsRequired": "服务名称为必填项",
    "serviceRepresentative": "服务代表",
    "services": "服务",
    "setBsr": "设置缓存器状态报告",
    "setTags": "设置标签",
    "setiD": "塞蒂D：",
    "settings": "设置",
    "sexOffenderBackgroundCheck": "性犯罪者背景调查",
    "sexualHarassmentTraining": "性骚扰培训",
    "shift": "班次：",
    "shift-End": "移动 - 结束",
    "shiftAlign": "移位对齐",
    "shiftAlignIsRequired": "需要平移对齐",
    "shiftDayWise": "班次（白天）",
    "shiftEnd": "班次结束",
    "shiftEndIsRequired": "需要换班结束",
    "shiftMarker": "移位标记",
    "shiftOverride": "班次覆盖",
    "shiftOverrideNotAvailable": "班次覆盖（不可用）",
    "shiftStart": "轮班开始",
    "shiftStartIsRequired": "需要 Shift 开始",
    "shifts": "轮班",
    "showBreak": "表演休息",
    "showGoogleMiles": "显示 Google 里程",
    "showRoute": "显示路线",
    "showUnassignedTrips": "显示未分配的行程",
    "signIn": "登录",
    "signInToYour": "登录您的帐户",
    "signature": "签名",
    "signatureIsRequired": "需要签名",
    "single": "单人",
    "skipSignature": "跳过签名",
    "smokeFreeVehiclesDriver": "无烟车辆（驾驶员理解）",
    "sms": "短信",
    "sms/dashboard": "短信/仪表板",
    "smsRequired": "需要短信",
    "sorryWeCouldntFind": "抱歉，我们找不到您要查找的页面。",
    "sort": "排序",
    "spaceTypeLabel": "空间类型",
    "spaceTypeRequired": "空间类型为必填项",
    "spaceTypefileIsRequired": "空间类型（文件）为必填项",
    "spaceTypesIsRequired": "空间类型为必填项",
    "spacetypeImage": "空间类型图像",
    "spacetypeIsRequired": "空间类型为必填项",
    "spacetypes": "空间类型",
    "spanishLanguageLabel": "西班牙语",
    "specialFare": "特别票价",
    "specialRequests": "特殊要求",
    "squareImageIsRecommended": "*建议使用方形图像",
    "ssl": "安全套接字层",
    "staff": "（工作人员）",
    "stagingTrips": "分期旅行",
    "stairsSteps": "楼梯台阶/秒",
    "stairsStepsIsRequired": "需要楼梯台阶",
    "standingOrderHeader": "常规订单",
    "startDate": "开始日期",
    "startDateIsRequired": "开始日期为必填项",
    "startTime": "开始时间",
    "startTimeIsRequired": "需要开始时间",
    "started": "开始",
    "startedAt": "开始于：",
    "startedTimeIsRequired": "开始时间为必填项",
    "statReport": "统计报告",
    "stateCode": "州代码",
    "stateCodeIsRequired": "需要州代码",
    "stateIsRequired": "状态为必填项",
    "statistics": "统计数据",
    "statusActive": "活跃",
    "statusInactive": "活跃中",
    "statusIsRequired": "状态为必填项",
    "statusLabel": "状态",
    "statuses": "状态",
    "statuss": "状态",
    "stop": "停止",
    "stopTimeIsRequired": "需要停止时间",
    "storageInformation": "存储信息",
    "submit": "提交",
    "suggestTime": "建议时间",
    "suggestedTime": "建议时间",
    "support": "支持",
    "svc": "服务中心",
    "sweep": "扫一扫",
    "sweepFile": "扫文件",
    "table": "表",
    "table-user": "表用户",
    "takeSignature": "签名",
    "taxInformation": "税务信息",
    "taxonomyCode": "分类代码",
    "tbTest": "结核病检测",
    "template": "模板",
    "templateIsRequired": "需要模板",
    "textAssistanceRequiredFor": "会员需要文本帮助。",
    "textLiveLinkTo": "通过短信向会员发送实时链接",
    "thirdParty": "第三方",
    "thisOperationWillComplete": "此操作将完成生成保险索赔文件（如行程日志、成绩单表格等）所需的信息。",
    "threshold": "阈值",
    "thresholdIsRequired": "需要阈值",
    "timeCalibration": "时间校准",
    "timeFormat": "时间格式",
    "timeFormatIsRequired": "时间格式为必填项",
    "timeIn": "时间",
    "timeInAt": "时间在",
    "timeInIsRequired": "需要时间",
    "timeLabel": "时间",
    "timeOut": "超时",
    "timeOutIsRequired": "需要超时",
    "timeRequired": "需要时间",
    "timeZone": "时区",
    "timeZoneIsRequired": "时区为必填项",
    "timein": "泰明",
    "timeline": "时间轴",
    "timelines": "时间表",
    "times": "×",
    "tipStatusIsRequired": "提示状态为必填项",
    "tipTitleIsRequired": "提示标题为必填项",
    "tiresInformation": "轮胎信息",
    "title": "标题",
    "titleIsRequired": "标题为必填项",
    "tls": "tls",
    "to": "到",
    "toIsRequired": "至 为必填项",
    "today": "今天",
    "toll-freeNumber": "免费电话号码",
    "toll-freeNumberIsRequired": "需要免费电话号码",
    "totalFare": "总票价",
    "totalFareIsRequired": "需填写总票价",
    "tp": "(TP)",
    "traffic": "交通",
    "travelAndSequence": "行程与顺序",
    "trial": "试用",
    "trialEnd": "试用结束",
    "tripAssistance": "旅行协助",
    "tripId": "行程ID",
    "tripIdLabel": "行程ID",
    "tripIdRequired": "需要旅行 ID",
    "tripInformation": "行程信息",
    "tripLogs": "行程日志",
    "tripQuota": "行程配额",
    "tripQuotaIsRequired": "需要行程配额",
    "tripReport": "行程报告",
    "tripRoute": "出行路线",
    "tripS": "行程",
    "tripSequenceLate": "行程顺序（晚）",
    "tripSequenceOnTime": "行程顺序（准时）",
    "tripStatus": "行程状态",
    "tripWise": "明智旅行",
    "trips": "行程",
    "tripsAdjustmentImportant": "行程调整（银行前重要）",
    "tripsFile": "行程文件",
    "tripsFileIsRequired": "需要行程文件",
    "tripsItinerary": "旅行行程",
    "tripsMapDashboard": "行程地图仪表板",
    "type": "类型",
    "typeAMessage": "输入消息......",
    "un-selectAll": "取消全选",
    "unassign": "取消分配",
    "unassigned": "未分配",
    "unassignedCancelled": "未分配 已取消",
    "unassignedTrips": "未分配的行程",
    "unconfirm": "取消确认",
    "undo": "撤消",
    "unknown": "未知",
    "unloadTimeIsRequired": "需要卸载时间",
    "unscheduled": "[未安排]",
    "upBaseAddress": "向上基地址",
    "updateAssists": "更新协助",
    "updateButton": "更新",
    "updateStatus": "更新状态",
    "uploadAFile": "上传文件",
    "uploadAnImage": "上传图片",
    "uploadJpegJpgOr": "上传 .jpeg、.jpg 或 .png 文件",
    "uploadTxtFile": "上传.txt 文件",
    "uploadXlsxXlsOr": "上传 .xlsx、.xls 或 .csv 文件",
    "urduLanguageLabel": "乌尔都语",
    "url": "网址",
    "useAPermanentAddress": "使用可以接收邮件的永久地址。",
    "useAuthenticSignatures": "使用真实的签名。",
    "useMemberPermanentAddress": "使用可以接收邮件的会员永久地址。",
    "useSettingAriaLabel": "使用设置",
    "user": "用户",
    "user-image": "用户形象",
    "user-img": "用户img",
    "userPhoto": "用户照片",
    "username": "用户名",
    "usernameIsRequired": "用户名为必填项",
    "users": "用户",
    "usingTheBelowForm": "使用下面的表单添加新的代理配置",
    "usingTheBelowForm2": "使用下面的表单添加新的电子邮件配置",
    "v1": "V1",
    "v2": "V2",
    "v3": "V3",
    "validityRange": "有效期",
    "validityRangeIsRequired": "有效期范围为必填项",
    "vehicle": "车辆",
    "vehicleDecalNumberIs": "需要车辆贴花号码",
    "vehicleGarage": "车库",
    "vehicleIdentificationNumberI": "需要车辆识别号码",
    "vehicleImageBack": "车辆图片返回",
    "vehicleImageFront": "车辆正面图像",
    "vehicleImageLeft": "车辆图像左",
    "vehicleImageRight": "车辆右像",
    "vehicleInspectionInPast": "过去12个月的车辆检查，并有回顾期。",
    "vehicleMakeIsRequired": "车辆品牌为必填项",
    "vehicleRecordCheckDot": "车辆记录检查 (DOT MVR)",
    "vehicleRecordCheckStandard": "车辆记录检查（标准检查）",
    "vehicleServiceNumberIs": "需要车辆服务号码",
    "vehicleTypeIsRequired": "车辆类型为必填项",
    "vehicleWise": "车辆智慧",
    "vehiclesFleet": "车辆/车队",
    "verifyCode": "验证码",
    "viewRoute": "查看路线",
    "viewTripsOnly": "仅查看行程",
    "vin": "车架号",
    "vinIsRequired": "需要车辆识别号",
    "violationIsRequired": "需要违规",
    "violationSets": "违规集",
    "vipExpiryDate": "VIP 有效期",
    "vipExpiryDateIs": "VIP 有效期为必填项",
    "vipLabel": "贵宾",
    "vipMembers": "贵宾会员",
    "virginia": "弗吉尼亚州",
    "visit": "参观",
    "voicemail": "语音信箱",
    "waitTime": "等待时间",
    "waitTimeCode": "等待时间代码",
    "waitTimeCodeIs": "需要等待时间代码",
    "waitTimeIsRequired": "需要等待时间",
    "wandererRisk": "流浪者风险",
    "warning": "警告",
    "weekendNightCode": "周末夜间代码",
    "weekendNightCodeIs": "需要周末夜间代码",
    "weeklyFee": "周费",
    "weeklyFeeIsRequired": "需要按周付费",
    "weightLabel": "重量",
    "weightRequired": "重量为必填项",
    "wheelchairRampInformation": "轮椅坡道信息",
    "wheelchairSecurementTraining": "轮椅固定训练（EXP）",
    "widthIsRequired": "宽度为必填项",
    "willCall": "会打电话",
    "willCall2359": "会打电话 (23:59)",
    "willCallActivated": "将调用激活",
    "willCallBracket": "[会打电话]",
    "willCallLabel": "会打电话",
    "willCallTrip": "将致电旅行",
    "wmrNumber": "WMR 号码",
    "wmrNumberIsRequired": "WMR 号码为必填项",
    "writeYourCommentHere": "在这里写下您的评论...",
    "yamsolLlc": "亚姆索尔有限责任公司",
    "year": "年份",
    "yearIsRequired": "年份为必填项",
    "yes": "是的",
    "yourCompany": "您的公司",
    "yourLicenseIsGoing": "您的许可证将于 2020 年 11 月 22 日到期。请在 Hoosier Transport 续签和更新您的许可证，以避免造成任何不便。",
    "zipCode": "邮政编码",
    "zipCodeIsRequired": "邮政编码为必填项",
    "zipIsRequired": "需要邮编",
    "zoneForIsRequired": "区域为必填项",
    "zoneName": "区域名称",
    "zones": "区域",
    "zoom": "变焦",
    "id": "ID",
    "escort": "护航",
    "spRate": "SP。率",
    "estFare": "美国东部时间。票价",
    "createdTime": "创建时间",
    "authNumber": "授权号",
    "appointmentTypes": "预约类型",
    "dvNotes": "DV笔记",
    "source": "来源",
    "trackingNo": "追踪号码",
    "roleOrSource": "角色/来源",
    "staffManager": "员工经理",
    "mobileNumber": "手机号码",
    "updatedAt": "更新于",
    "createdAt": "创建于",
    "version": "版本",
    "shiftLabel": "转变",
    "role": "角色",
    "puTime": "PU时间",
    "doTime": "溶解氧时间",
    "puDate": "PU日期",
    "doDate": "执行日期",
    "memberInfo": "会员信息",
    "facilityVeh": "设施 - Veh",
    "noMemberName": "编号/会员姓名",
    "dosLabel": "DOS",
    "losLabel": "LOS",
    "pickupTime": "接载时间",
    "dropoffTime": "还车时间",
    "mileage": "里程",
    "reservationNoLabel": "预订号",
    "claimed": "声称",
    "onboardStatus": "船上状态",
    "insurance": "保险",
    "loadTime": "加载时间",
    "unloadTime": "卸货时间",
    "totalTrips": "总行程",
    "totalIntake": "总摄入量",
    "serviceCharges": "服务费",
    "companyIntake": "公司摄入量",
    "remainingAmount": "剩余金额",
    "cashPayment": "现金支付",
    "creditPayment": "信用支付",
    "adjustedAmount": "调整金额",
    "balance": "平衡",
    "driverEarnings": "司机收入",
    "earnings": "收益",
    "cash": "现金",
    "credit": "信用",
    "adjusted": "调整后",
    "total": "合计",
    "early": "早期",
    "onTime": "准时",
    "late": "迟到",
    "earlyTimeScore": "早期得分",
    "onTimeScore": "准时分数",
    "lateTimeScore": "迟到分数",
    "actualOnTimeScore": "实际准时分数",
    "aptTime": "亚太时间",
    "arrivedTime": "到达时间",
    "message": "留言",
    "error": "错误",
    "sentDate": "发送日期",
    "createdDate": "创建日期",
    "memberId": "会员编号",
    "otpStatus": "一次性密码状态",
    "otpMinutes": "一次性密码会议记录",
    "oneHourViolation": "1 小时违规",
    "filePath": "文件路径",
    "mrnLabel": "会员记录号 (MRN)",
    "timestamps": "时间戳",
    "trackId": "曲目编号",
    "location": "地点",
    "report": "报告",
    "currentMileage": "当前里程",
    "inspectedBy": "检查者",
    "inspectionCenter": "检验中心",
    "result": "结果",
    "passed": "通过",
    "failed": "失败",
    "dateCorrected": "更正日期",
    "frontDriverPassengerCompartment": "前驾驶室/乘客室",
    "patientCompartment": "病人舱",
    "exteriorVehicle": "外饰车",
    "underHoodCompartment": "引擎盖下/隔间",
    "fluidsEngine": "液体/发动机",
    "brakeTest": "刹车测试",
    "tiresWheels": "轮胎/车轮",
    "brakes": "刹车",
    "bodyFrame": "车身和框架",
    "fuelSystem": "燃油系统",
    "exhaustSystem": "排气系统",
    "cost": "成本",
    "category": "类别",
    "shiftTime": "轮班时间",
    "timeInTimeOut": "入时/超时",
    "mealTakenDue": "已吃/到期膳食",
    "restTakenDue": "休息/到期",
    "workingHours": "工作时间",
    "breakHours": "休息时间",
    "loadedMilesRate": "满载里程率",
    "deadMilesRate": "死里程率",
    "account": "账户",
    "amount": "金额",
    "approxDo": "〜DO",
    "approxPu": "~PU",
    "approxTimeLabel": "预计时间",
    "approxPuLabel": "预计接载",
    "approxDoLabel": "预计送达",
    "currentTrip": "当前行程",
    "appt": "阿普特",
    "arrive": "到达",
    "arriveDist": "到达区",
    "availability": "可用性",
    "breaksAck": "中断 Ack。",
    "breaksDue": "休息时间",
    "breaksTaken": "休息时间",
    "bucket": "桶",
    "bumped": "碰撞",
    "cads": "卡兹",
    "cancelCharge": "取消收费",
    "cancelledTrips": "取消的行程",
    "changeReason": "变更原因",
    "claimAmount": "索赔金额",
    "claimId": "索赔 ID",
    "claimPaymentAmount": "索赔金额",
    "company": "公司简介",
    "companyIntakeAfterThreshold": "阈值后的公司吸纳量",
    "completedTrips": "已完成的行程",
    "components": "组件",
    "dateLabel": "日期",
    "day": "日",
    "declined": "拒绝",
    "distDiff": "区。差异。",
    "distance": "距离",
    "distanceViolet": "距离紫。",
    "doAddress": "指定地址",
    "driverIntakeAfterThreshold": "阈值后驾驶员摄入量",
    "dropoffDiff": "下降差异。",
    "duration": "持续时间",
    "engaged": "订婚了",
    "eta": "ETA",
    "events": "活动",
    "fee": "费用",
    "flatFee": "固定费用",
    "fromTime": "从时间",
    "group": "集团",
    "ignored": "被忽略",
    "lateReason": "迟到原因",
    "loadUnloadTime": "装载/卸载时间",
    "loadedMiles": "已加载里程",
    "maxFactor": "最大因素",
    "minimumFare": "最低票价",
    "netProfit": "净利润",
    "newDist": "新区",
    "noOfTrips": "出行次数",
    "noShowCharge": "缺席费用",
    "odometerStartEnd": "里程表开始-结束",
    "onboardViolet": "船上的紫罗兰。",
    "otherViolet": "其他紫罗兰。",
    "outgoings": "支出",
    "passedFailed": "通过/失败",
    "patientName": "患者姓名",
    "pdOrder": "P/D 订单",
    "perform": "执行",
    "performDist": "执行距离",
    "phone": "电话",
    "phoneNo": "电话号码",
    "pickupDiff": "拾音器差异",
    "platformCharges": "平台收费：",
    "preDist": "预分配。",
    "price": "价格",
    "puAddress": "PU地址",
    "puDoAddress": "PU - DO 地址",
    "remaining": "剩余",
    "restHours": "休息时间",
    "returned": "已返回",
    "rigHash": "装备#",
    "rigType": "钻机类型",
    "service": "服务",
    "serviceDate": "服务日期",
    "sr": "先生。",
    "srHash": "高级#",
    "status": "状态",
    "timeDifference": "时差",
    "timeStamps": "时间戳",
    "timeWise": "时间明智",
    "tip": "提示",
    "toTime": "到时间",
    "toll": "收费站",
    "totalDeadMileRate": "总死英里率",
    "totalEarning": "总收入",
    "totalEarningsColon": "总收入：",
    "totalLoadedMileRate": "总装载里程率",
    "travel": "旅行",
    "tripEarnings": "旅行收入",
    "willCallStatus": "将呼叫状态",
    "adjustTrips": "调整行程",
    "amendmentReq": "修改要求",
    "assistRequired": "需要协助吗？",
    "associateTo": "关联至",
    "broker": "经纪人",
    "calculate": "计算",
    "clientIdMemberId": "客户 ID / 会员 ID / MA# / AHCCCS#",
    "displayName": "显示名称",
    "documentExpiry": "文件到期",
    "driverGrievanceReport": "司机申诉报告",
    "driverSignature": "司机签名",
    "generalInformation": "一般信息",
    "generateReport": "生成报告",
    "googleApproximation": "谷歌近似",
    "localApproximation": "局部近似",
    "ltiReport": "长期TI报告",
    "markConfirmed": "标记已确认",
    "markReady": "标记就绪",
    "unmarkReady": "取消标记就绪",
    "markUnassigned": "标记为未分配",
    "markVoicemail": "马克语音信箱",
    "milesReport": "里程报告",
    "modifierTwo": "修改器二",
    "otherReason": "其他原因",
    "partialEdit": "部分编辑",
    "plusAdd": "+ 添加",
    "rating": "评级",
    "rawTripSummary": "原始旅行摘要",
    "receiverEmail": "收件人邮箱",
    "state": "状态",
    "tripsReport": "旅行报告",
    "update": "更新",
    "showing": "显示中",
    "entries": "条目",
    "enterInPercent": "输入%",
    "enterInPercentage": "输入百分比",
    "selectCorporatePlaceholder": "-- 选择企业 --",
    "grievance": "申诉",
    "itemLost": "物品丢失",
    "generalShift": "一般转变",
    "addCorporate": "添加公司",
    "addCompanies": "添加公司",
    "Accidental Reports": "意外报告",
    "Addons": "插件",
    "Announcements": "公告",
    "Appointment Types": "预约类型",
    "Billing": "计费",
    "Business Reports": "业务报告",
    "CheckList": "清单",
    "Dashboard": "仪表板",
    "Availability": "可用性",
    "Dirt Road": "土路",
    "Driver Alerts": "驾驶员警报",
    "Driver Expense": "司机费用",
    "Driver Score": "驾驶员分数",
    "Driver Wise": "驾驶员智慧",
    "EDI 835": "电子数据交换835",
    "Earnings": "收益",
    "Extras": "附加功能",
    "Fleet": "舰队",
    "Grievance / Item Lost": "申诉/物品丢失",
    "Helping Material": "帮助材料",
    "Invoice": "发票",
    "Itineries": "行程",
    "Maintenance": "维护保养",
    "Manifest": "清单",
    "Manual": "手册",
    "Modifier Codes": "修饰符代码",
    "Nemt Pro Tips": "Nemt 专业提示",
    "Operations": "运营",
    "Outbounding": "出站",
    "Planner": "规划师",
    "Primary Diagnosis": "初步诊断",
    "Pro Tips": "专业提示",
    "Push to Talk": "一键通",
    "Rates": "价格",
    "Reports": "报告",
    "Routing": "路由",
    "SMS": "短信",
    "Statistics": "统计数据",
    "Support": "支持",
    "TRFs & Claims": "TRF 和索赔",
    "TRFs Templates": "TRF 模板",
    "Trips": "行程",
    "Vehicle Expense": "车辆费用",
    "Vehicle Inspection": "车辆检验",
    "Zones": "区域",
    "back": "返回",
    "next": "下一页",
    "previous": "上一页",
    "upload": "上传",
    "export": "出口",
    "import": "进口",
    "refresh": "刷新",
    "edit": "编辑",
    "view": "查看",
    "loading": "正在加载...",
    "deselectAll": "取消全选",
    "more": "更多...",
    "clearFilters": "清除过滤器",
    "clearFilter": "清除过滤器",
    "clearAll": "全部清除",
    "applyFilters": "应用过滤器",
    "applyFilter": "应用过滤器",
    "noData": "无数据",
    "noResults": "没有结果",
    "ok": "OK",
    "filters": "过滤器",
    "Staging": "分期",
    "Assigned": "已分配",

    "memberInfoHeader": "会员信息",
    "serviceInfoHeader": "服务信息",
    "dateTimeHeader": "日期和时间",
    "pickupTimeLabel": "接送时间",
    "dropoffTimeLabel": "送达时间",
    "cityLabel": "城市",
    "stateLabel": "州/省",
    "zipCodeLabel": "邮政编码",
    "notesHeader": "备注",
    "attachmentsHeader": "附件",
    "paymentStatus": "支付状态",
    "assistedBy": "协助者:",
    "insuranceId": "保险 ID",
    "ipaNumber": "IPA 号码",
    "passengerName": "乘客姓名",
    "cellPhone": "移动电话",
    "dob": "出生日期",
    "clientId": "客户 ID",
    "forDriver": "给司机",
    "actualMiles": "实际里程",
    "paymentMode": "支付方式",
    "deadMinutes": "空驶分钟",
    "tripMiles": "行程里程",
    "tripTime": "行程时间",
    "totalTripMiles": "总行程里程",
    "totalTripTime": "总行程时间",
    "totalTripMilesInclDeadMiles": "总行程里程（包括空驶里程）",
    "totalTripTimeInclDeadMinutes": "总行程时间（包括空驶分钟）",
    "odometerEnd": "里程表结束",
    "enRoute": "在途中",
    "readySince": "就绪自:",
    "app": "应用程序",
    "availabilityDays": "可用天数",
    "joiningDate": "入职日期",
    "sunday": "周日",
    "sun": "周日",
    "monday": "周一",
    "mon": "周一",
    "tuesday": "周二",
    "tue": "周二",
    "wednesday": "周三",
    "wed": "周三",
    "thursday": "周四",
    "thu": "周四",
    "friday": "周五",
    "fri": "周五",
    "saturday": "周六",
    "sat": "周六",
    "dayMon": "周一",
    "dayTue": "周二",
    "dayWed": "周三",
    "dayThu": "周四",
    "dayFri": "周五",
    "daySat": "周六",
    "daySun": "周日",
    "addressPicker": "地址选择器",
    "smsConfiguration": "短信配置",
    "confirmationTemplate": "确认模板",
    "default": "默认",
    "boldage": "Boldage"
};
